import { Component, OnDestroy, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'sn-iframe',
	template: require('./iframe.component.html'),
	styles: [require('./iframe.component.scss')]
})
export class IframeComponent implements OnInit, OnDestroy {
	urlToLoad: SafeResourceUrl = null;
	body: HTMLElement;

	private unsubscribe: Subject<void> = new Subject();

	constructor(private iframeService: IframeService) {}

	ngOnInit(): void {
		this.body = document.querySelector('body');
		this.iframeService.urlIframeUrl
			.pipe(
				takeUntil(this.unsubscribe),
				skip(1)
			)
			.subscribe((url: string): void => {
				this.changeBodyClass(url);
				this.urlToLoad = url;
			});
	}

	changeBodyClass(url: string): void {
		url
			? this.body.classList.add('disable-scroll')
			: this.body.classList.remove('disable-scroll');
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/iframe/iframe.component.ts